/* TodayPage — Phase 62.3 (May 8, 2026): renamed "Forecast" in the pager,
 * moved to the LAST slide, and stripped of the "Why this forecast?" /
 * "Past 24 hours" entry-points. The Seasonal Outlook (next 7 months) is
 * the sole content here now — a long-horizon companion to the Verdict
 * page's day-of-day intelligence.
 */
import { motion } from "framer-motion";
import LocationBar from "@/components/v2/LocationBar";
import SeasonalOutlook from "@/components/v2/SeasonalOutlook";

export default function TodayPage({ location, onSelectLocation, theme }) {
  return (
    <div
      className="h-full w-full flex flex-col px-5 pt-2 pb-24"
      data-testid="page-today"
      style={{ color: theme.textPrimary }}
    >
      <div className="shrink-0">
        <LocationBar
          location={location}
          onSelect={onSelectLocation}
          theme={theme}
        />
      </div>

      <div className="flex-1 flex flex-col gap-3 mt-3 min-h-0 overflow-y-auto -mx-1 px-1" style={{ scrollbarWidth: "none" }}>
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
        >
          <div className="flex items-baseline justify-between mb-1.5 px-0.5">
            <span
              className="text-[10px] font-bold uppercase tracking-[0.2em]"
              style={{ color: theme.textMuted }}
            >
              Next 7 months · your location
            </span>
          </div>
          <SeasonalOutlook location={location} theme={theme} />
        </motion.div>
      </div>
    </div>
  );
}
